import { render } from "./OnboardingPopup.vue?vue&type=template&id=82ec7412&scoped=true"
import script from "./OnboardingPopup.vue?vue&type=script&lang=js"
export * from "./OnboardingPopup.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./OnboardingPopup.vue?vue&type=style&index=0&id=82ec7412&lang=less&module=true&scoped=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-82ec7412"]])

export default __exports__